export default function ExpandArrowBottom() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none" className="ef-coupon-card-rules-r-icon">
            <ellipse cx="10" cy="9.94778" rx="10" ry="9.94778" transform="matrix(1 0 0 -1 0 19.8958)" fill="#EEF4FF" />
            <path d="M8.51953 13.5952L12.186 9.94788L8.51953 6.30054" stroke="#2673FF" strokeWidth="0.746667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}
